import React, { useEffect, useState, useMemo } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Accordion from '../components/Accordion';
import CategoryFilter from '../components/CategoryFilter';
import networkData from '../data/networkData';

const NetworkPage = () => {
  const { networkId } = useParams();
  const location = useLocation();
  const [highlightedSyntaxId, setHighlightedSyntaxId] = useState(null);
  const [showCursor, setShowCursor] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState('all');

  const network = networkData.find(
    (net) => net.name.toLowerCase().replace(/\s+/g, '-') === networkId
  );

  const categories = useMemo(() => {
    if (!network) return [];
    const uniqueCategories = new Set(network.syntaxes.map(syntax => syntax.category));
    return ['all', ...Array.from(uniqueCategories)];
  }, [network]);

  const filteredSyntaxes = useMemo(() => {
    if (!network) return [];
    return selectedCategory === 'all'
      ? network.syntaxes
      : network.syntaxes.filter(syntax => syntax.category === selectedCategory);
  }, [network, selectedCategory]);

  useEffect(() => {
    if (location.state && location.state.highlightedSyntaxId) {
      setHighlightedSyntaxId(location.state.highlightedSyntaxId);
      setShowCursor(true);
      const element = document.getElementById(`syntax-${location.state.highlightedSyntaxId}`);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.state]);

  const handleAccordionToggle = (syntaxId, isOpen) => {
    if (syntaxId === highlightedSyntaxId && !isOpen) {
      setShowCursor(false);
    }
  };

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setHighlightedSyntaxId(null);
    setShowCursor(false);
  };

  if (!network) {
    return (
      <div className="container mx-auto px-4 pt-20">
        <h1 className="text-4xl font-bold mt-8 mb-4">Réseau non trouvé</h1>
        <p className="text-xl mb-8">Désolé, nous n'avons pas pu trouver le réseau que vous cherchez.</p>
      </div>
    );
  }

  return (
    <div className="container lg:px-24 mx-auto px-4 pt-20">
      <h1 className="text-4xl font-bold mt-8 mb-4">{network.name}</h1>
      <CategoryFilter 
        categories={categories}
        selectedCategory={selectedCategory}
        onCategoryChange={handleCategoryChange}
      />
      <div className="mt-8">
        {filteredSyntaxes.map((syntax) => (
          <div key={syntax.id} id={`syntax-${syntax.id}`} className="relative">
            <Accordion 
              title={syntax.title} 
              content={syntax.content} 
              isInitiallyOpen={syntax.id === highlightedSyntaxId}
              onToggle={(isOpen) => handleAccordionToggle(syntax.id, isOpen)}
              network={network}
              syntax={syntax}
            />
            {showCursor && syntax.id === highlightedSyntaxId && (
              <span className="absolute left-[-20px] top-[10px] text-2xl">👉</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NetworkPage;